// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"setPasswordPage_parentContainer__3oKfa","childContainer":"setPasswordPage_childContainer__2iYiW","logo":"setPasswordPage_logo__20jgq"};